import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  query GetSubscriptionsV2ByToken($token: String!, $page: Int, $perPage: Int, $filter: AutoFilledFilterFindManysubscriptionsV2Input) {
  getSubscriptionsV2ByToken(token: $token, page: $page, perPage: $perPage, filter: $filter) {
    items {
      _id
      startDate
      endDate
      cancelDate
      frequency
      status
      amountDue
      nextBillingDate
      seats
      gracePeriodEnd
      company {
        _id
        name
      }
      customer {
        _id
        email
        companyName
        defaultPaymentMethod
        defaultPaymentMethodObj {
          type
          name
          companyId
          provider
          customerId
          expired
          _id
          updatedAt
          createdAt
          card {
            cardNo
            cardType
            holder
            expiry
          }
        }
      }
      product {
        _id
        name
        description
        defaultPrice
        unitLabel
        group
        currency
      }
      pricing {
        _id
        name
        flatFee
        pricingModel
        tieredPricing {
          _id
          perUnit
          firstUnit
          lastUnit
          flatFee
        }
        months
        years
      }
      downgradeToPriceObj {
        _id
        createdAt
        description
        months
        name
        years
      }
      downgradeToProductObj {
        _id
        name
        group
        description
      }
      changes {
        _id
      }
      payments {
        _id
      }
      nextPaymentAttemptDate
    }
  }
}
`;
